import React, { useState, Fragment } from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { deleteRecord } from "../../store/action/deleteRecords";
import { fetchEdidata } from "../../store/action/ediResponse";
import { clearSelectedEdiRecords } from "../../store/action/selectedRecords";
import Tooltip from "@material-ui/core/Tooltip";
import {
  clearEdiResponseRecords,
  clearEdiRequestRecords,
} from "../../store/action/respRecordsClear";

function EdiDeletion(props) {
  const [open, setOpen] = React.useState(false);
  const [dimmer, setDimmer] = useState(undefined);
  const [size, setSize] = useState(undefined);
  const shipmentID = useSelector(
    (state) => window.shipmentId || state.isf?.shipmentID || props.shipmentId
  );
  const selectedRow = useSelector((state) => state.rowSelected?.selectedRow);
  const country = useSelector(
    (state) =>
      window.shipmentCountry ||
      state.isf?.currentJobData.shipment.countryOfBusiness ||
      props.countryOfBusiness
  );
  const deletionInProgress = useSelector(
    (state) => state.ediRecordDeleted?.loading
  );
  const usFormType =
    useSelector((state) => state.formTypeReducer?.usFormType) || "ES";
  const dispatch = useDispatch();
  const onModalOpen = () => {
    setOpen(true);
    setDimmer("blurring");
    setSize("tiny");
  };

  const onModalClose = () => {
    setOpen(false);
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    await dispatch(deleteRecord(selectedRow.requestid, country, usFormType));

    await setOpen(false);
    dispatch(clearSelectedEdiRecords());
    dispatch(clearEdiResponseRecords());
    dispatch(clearEdiRequestRecords());

    dispatch(fetchEdidata(shipmentId, shipmentCountry));
  };

  return (
    <div>
      <Fragment>
        <Modal
          onClose={onModalClose}
          onOpen={onModalOpen}
          open={open}
          dimmer={dimmer}
          size={size}
          trigger={
            <Tooltip
              title="Delete Selected Request"
              placement="top"
              arrow
              aria-label="Delete Request"
            >
              <button className="trigger-deletion">
                Delete Selected Request
              </button>
            </Tooltip>
          }
        >
          <Modal.Content>
            <Modal.Description>
              <p style={{ fontSize: "15px" }}>
                Your action will delete record with RequestID :{" "}
                <b>{selectedRow?.requestid} </b>
                from ShipmentID : <b>{shipmentID}</b>
              </p>
            </Modal.Description>
            <Header>Are you sure?</Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              disabled={deletionInProgress ? true : false}
              color="red"
              onClick={() => setOpen(false)}
            >
              Nope
            </Button>
            <Button
              disabled={deletionInProgress ? true : false}
              content="Yes"
              labelPosition="right"
              icon="checkmark"
              onClick={onSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      </Fragment>
    </div>
  );
}

export default EdiDeletion;
